// src/router/auth.js
const devRoutes = [

    {
        path: "/test",
        name: "Test",
        component: () => import("../views/auth/TestView.vue"),
      },
      {
        path: "/admin-dash",
        name: "AdminDash",
        component: () => import("../views/pages/dev/AdminDash.vue"),
      },
      {
        path: "/elements",
        name: "Elements",
        component: () => import("../views/pages/dev/Elements.vue"),
      },
      {
        path: "/charts",
        name: "Charts",
        component: () => import("../views/pages/dev/Charts.vue"),
      },
      {
        path: "/roles",
        name: "Roles",
        component: () => import("../views/pages/dev/Roles.vue"),
      },
      {
        path: "/permissions",
        name: "Permissions",
        component: () => import("../views/pages/dev/Permissions.vue"),
      },
      {
        path: "/users",
        name: "Users",
        component: () => import("../views/pages/dev/Users.vue"),
      },
  ];
  
  export default devRoutes;
  